import {rootApiGroup} from '@integraciones_doc24/wehealthy-api';
import {ApiErrors} from '@integraciones_doc24/wehealthy-api/types/errors';
import {getArticleListEndpoint} from '@integraciones_doc24/wehealthy-api/root/content/article/getList';
import {getArticleEndpoint} from '@integraciones_doc24/wehealthy-api/root/content/article/get';
import {updateArticleEndpoint} from '@integraciones_doc24/wehealthy-api/root/content/article/update';
import {createArticleEndpoint} from '@integraciones_doc24/wehealthy-api/root/content/article/create';
import {deleteArticleEndpoint} from '@integraciones_doc24/wehealthy-api/root/content/article/delete';
import {publishArticleEndpoint} from '@integraciones_doc24/wehealthy-api/root/content/article/publish';
import {unpublishArticleEndpoint} from '@integraciones_doc24/wehealthy-api/root/content/article/unpublish';
import {getArticleImageUploadParametersEndpoint} from '@integraciones_doc24/wehealthy-api/root/content/article/getImageUploadParameters';
import {getTagListEndpoint} from '@integraciones_doc24/wehealthy-api/root/content/article/tag/getList';
import {createTagEndpoint} from '@integraciones_doc24/wehealthy-api/root/content/article/tag/create';

import {initApiConsumer} from '@urpi/consumer';
import {getBackEnd} from './backEndUrl';
import {useStore} from 'react-redux';
import {articulo} from '../types/general-types';

const backendUrl = getBackEnd();

const apiConsumer = initApiConsumer<ApiErrors.All>(
  `${backendUrl}/api`,
  rootApiGroup,
);
const getArticlesEndPoint = apiConsumer(getArticleListEndpoint);

export const getArticlesList = async (token: string) => {
  try {
    const articles = await getArticlesEndPoint(
      {query: {}},
      {headers: {authorization: `Bearer ${token}`}},
    );
    return articles;
  } catch (e) {
    return 'error';
  }
};

const getArticleEndPoint = apiConsumer(getArticleEndpoint);

export const getArticle = async (key: string, token: string | null) => {
  try {
    const article = await getArticleEndPoint(
      {routeParams: {key: key}},
      {headers: {authorization: `Bearer ${token}`}},
    );
    return article;
  } catch (e) {
    return 'error';
  }
};

const updateArticleendpoint = apiConsumer(updateArticleEndpoint);

export const updateArticle = async (
  key: string,
  token: string | null,
  articulo: articulo,
) => {
  const {title, brief, content, tags, sources, languages, notification} =
    articulo;
  try {
    const article = await updateArticleendpoint(
      {
        routeParams: {key: key},
        body: {
          title: title,
          brief: brief,
          content: content,
          tags: tags,
          sources: sources,
          languages: languages,
          notification: notification,
        },
      },
      {headers: {authorization: `Bearer ${token}`}},
    );
    return article;
  } catch (e) {
    return 'error';
  }
};

const createArticleendpoint = apiConsumer(createArticleEndpoint);

export const createArticle = async (
  token: string | null,
  articulo: articulo,
  id?: string,
) => {
  const {title, brief, content, tags, sources, languages, notification} =
    articulo;
  try {
    const article = await createArticleendpoint(
      {
        body: {
          title: title,
          brief: brief,
          content: content,
          tags: tags,
          sources: sources,
          id: id,
          languages,
          notification,
        },
      },
      {headers: {authorization: `Bearer ${token}`}},
    );
    return article;
  } catch (e) {
    return 'error';
  }
};

const deleteArticleendpoint = apiConsumer(deleteArticleEndpoint);

export const deleteArticle = async (key: string, token: string | null) => {
  try {
    const article = await deleteArticleendpoint(
      {routeParams: {key: key}},
      {headers: {authorization: `Bearer ${token}`}},
    );
    return article;
  } catch (e) {
    return 'error';
  }
};

export const useGetArticleImageUploadParametersRequest = (token: string) => {
  const request = apiConsumer(getArticleImageUploadParametersEndpoint);
  return async (articleId: string, fileName: string, fileType: string) => {
    const response = await request(
      {
        query: {fileName, fileType},
        routeParams: {key: articleId},
      },
      {headers: {authorization: `Bearer ${token}`}},
    );
    return response.data;
  };
};

const publishArticleendpoint = apiConsumer(publishArticleEndpoint);

export const publishArticle = async (key: string, token: string | null) => {
  try {
    const article = await publishArticleendpoint(
      {routeParams: {key: key}},
      {headers: {authorization: `Bearer ${token}`}},
    );
    return article;
  } catch (e) {
    return 'error';
  }
};

const unPublishArticleendpoint = apiConsumer(unpublishArticleEndpoint);

export const unPublishArticle = async (key: string, token: string | null) => {
  try {
    const article = await unPublishArticleendpoint(
      {routeParams: {key: key}},
      {headers: {authorization: `Bearer ${token}`}},
    );
    return article;
  } catch (e) {
    return 'error';
  }
};

export function useProtectedThing() {
  const store = useStore();
  const state = store.getState();
  const dispatch = store.dispatch;

  function getProtectedThing() {
    console.log(state);
    dispatch({type: 'MY_ACTION'});
  }

  return {getProtectedThing};
}

const getArticlesTagListEndPoint = apiConsumer(getTagListEndpoint);

export const getArticlesTagList = async (token: string) => {
  try {
    const articles = await getArticlesTagListEndPoint(
      {query: {}},
      {headers: {authorization: `Bearer ${token}`}},
    );
    return articles;
  } catch (e) {
    return 'error';
  }
};

const createArticleTagsEndpoint = apiConsumer(createTagEndpoint);

export const createArticleTag = async (token: string, description: string) => {
  try {
    const tag = await createArticleTagsEndpoint(
      {body: {description}},
      {headers: {authorization: `Bearer ${token}`}},
    );
    return tag;
  } catch (e) {
    return 'error';
  }
};
